module.exports = __webpack_public_path__ + "img/chargebee.9f2937b9.svg";